var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilWriteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62.285 80.044",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.785 59.793V13.716a6.58 6.58 0 0 0-6.581-6.58H15.713c-3.638 0-6.59 2.946-6.59 6.58v59.24c0 3.633 2.956 6.58 6.59 6.58h26.32L61.785 59.79v.004Z",
    fill: "none",
    stroke: "#f8f6f4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.785 59.797H42.033v19.747",
    fill: "none",
    stroke: "#f8f6f4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.54 54.342a.736.736 0 0 1-.454.21L21.11 44.57a.726.726 0 0 1 .21-.455L37.847 27.59a.73.73 0 0 1 1.03 0l9.193 9.194a.73.73 0 0 1 0 1.03L31.545 54.337l-.005.004Z",
    fill: "#fdbc4f",
    stroke: "#f8f6f4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.435 20.999a2.188 2.188 0 0 1 3.093 0l7.13 7.13c.854.854.854 2.24 0 3.093l-6.079 6.08-10.223-10.224 6.08-6.08Z",
    fill: "none",
    stroke: "#f8f6f4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m40.708 34.949-9.91 9.91",
    fill: "none",
    stroke: "#f8f6f4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m31.086 54.555-11.712 2.523a.727.727 0 0 1-.786-.79l2.523-11.716",
    fill: "none"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m31.086 54.555-11.712 2.523a.727.727 0 0 1-.786-.79l2.523-11.716",
    fill: "none",
    stroke: "#f8f6f4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m23.632 56.151-3.2 1.171-1.854-.244V54.8l.922-2.776 4.132 4.131v-.004Z",
    fill: "#f8f6f4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.354 54.526 21.131 44.302l10.223 10.224Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.354 54.526 21.131 44.302",
    fill: "none",
    stroke: "#f8f6f4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53.166 7.081A6.58 6.58 0 0 0 46.585.5H7.09C3.452.5.5 3.447.5 7.081v59.24c0 3.633 2.956 6.58 6.59 6.58h1.64",
    fill: "none",
    stroke: "#f8f6f4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilWriteIcon);
export default __webpack_public_path__ + "static/media/pencil_write_icon.770f04f4c674089e2b81e927b11dcba9.svg";
export { ForwardRef as ReactComponent };